import { FC, Fragment } from 'react';
import { useFormContext } from 'react-hook-form';
import { Grid, IconButton, useMediaQuery, useTheme } from '@mui/material';
import { TrashIcon } from '~/icons';
import DataUploaderController from './DataUploaderController';
import DataUploaderNetworkIdController from './DataUploaderNetworkIdController';

interface DataUploaderFormProps {
  index: number;
  onRemove: (index: number) => void;
  field: Record<'id', string>;
  disabled?: boolean;
}

const DataUploaderForm: FC<DataUploaderFormProps> = ({ index, field, onRemove, disabled }) => {
  const { watch } = useFormContext();
  const fieldValues = watch('data_uploaders') ?? [];
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Fragment key={field?.id}>
      <Grid size={6}>
        <DataUploaderController index={index} onRemove={onRemove} disabled={disabled} />
      </Grid>
      <Grid size={5}>
        <DataUploaderNetworkIdController index={index} />
      </Grid>
      {index !== 0 && (
        <Grid size={1} alignSelf="center" pt={3}>
          <IconButton
            disabled={disabled}
            size={isSmallScreen ? 'small' : 'large'}
            color="error"
            data-testid={`data_uploader.${fieldValues[index]}`}
            onClick={() => onRemove(index)}
          >
            <TrashIcon />
          </IconButton>
        </Grid>
      )}
    </Fragment>
  );
};

export default DataUploaderForm;
